'use strict';

import { observable, configure, action, makeObservable } from "mobx";
configure({enforceActions: 'always'});

import PlanEvents from '@uw-it-sis/lib-react-myplan/lib/PlanEvents';
import events from "@uw-it-sis/lib-react/lib/Events";

class PlanItemModalStore {
    openAction = {};

    open = false;

    constructor() {
        makeObservable(this, {
            openAction: observable,
            open: observable,
            mount: action,
            openModal: action,
            closeModal: action
        });
    }

    mount() {
        this.open = false;
        this.modified = false;

        events.listen(PlanEvents.planItemAdded, () => this.setModified());
        events.listen(PlanEvents.planItemRemoved, () => this.setModified());
    }

    unmount() {
        events.remove(PlanEvents.planItemAdded, () => this.setModified());
        events.remove(PlanEvents.planItemRemoved, () => this.setModified());
    }

    openModal(actionType, data, additionalAnalytics) {
        this.open = true;
        this.openAction = {
            actionType: actionType,
            data: data,
            additionalAnalytics: additionalAnalytics
        };
        if ( actionType === "update" ) {
            let planItem = document.getElementById(`plan-item-${data.planItemDataObject.id}`);
            if (planItem) {
                planItem.classList.remove("highlight");
            }
        }
    }

    closeModal() {
        this.open = false;
        if ( this.modified && this.openAction.actionType === "update" ) {
            let planItemId = this.openAction.data.planItemDataObject.id;
            let planItem = document.getElementById(`plan-item-${planItemId}`);
            if (planItem) {
                planItem.scrollIntoView({
                    behavior: "smooth",
                    block: "center"
                });
                planItem.classList.add("highlight");
            }
        }
        this.openAction = {};
    }

    isOpen() {
        return this.open;
    }

    getActionType() {
        if (!this.isOpen()) {
            return undefined;
        }

        return this.openAction.actionType;
    }

    getData() {
        if (!this.isOpen()) {
            return undefined;
        }

        return this.openAction.data;
    }

    getAdditionalAnalytics() {
        if (!this.isOpen()) {
            return undefined;
        }

        return this.openAction.additionalAnalytics;
    }

    setModified() {
        if (this.openAction.actionType === "update") {
            this.modified = true;
        }
    }
}

export default new PlanItemModalStore();